<template>
    <!--
        作者：kmdshop
        时间：2019-10-24
        描述：sku管理
    -->
    <div class="product-list">
      <!--搜索表单-->

      <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
  
        <!-- <el-form-item label="用户名称/手机号/编号(平台只能给业务员定价)"><el-input size="small" v-model="searchForm.user_search" 
            placeholder="请输入用户名称/手机号/编号"></el-input></el-form-item> -->

            <!-- <el-button @click="onSubmit" icon="el-icon-plus">查询</el-button> -->
        <el-form-item>
          <el-button @click="openGetuser('ywy')" icon="el-icon-plus">选择业务员</el-button>
            </el-form-item>
      </el-form>
    </div>


    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="userTableData" border style="width: 100%" 
        v-loading="loading" >
        <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
          <el-table-column prop="nickName" label="昵称" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.nickName }}</p>

            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">

              <p>{{ scope.row.mobile }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="is_forbidden" label="状态" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.is_forbidden==0">
                <p>启用</p>
              </div>
              <div v-if="scope.row.is_forbidden==1">
                <p>禁用</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="avatarUrl" label="微信头像">
            <template slot-scope="scope">
              <div v-if="scope.row.avatarUrl">
                <img :src="scope.row.avatarUrl" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
 
          <el-table-column prop="" label="会员等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade_id == 0">无等级</span>
              <span v-else>{{ scope.row.grade ? scope.row.grade.name : '' }}</span>
            </template>
          </el-table-column>
    

          <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
         
        </el-table>
      </div>

    </div>


    <div class="common-seach-wrap" style="margin-top: 20px;" v-if="userTableData.length >0">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item label="编码"><el-input size="small" v-model="searchForm.product_no" :placeholder="product_no_search"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div class="product-content"  v-if="userTableData.length >0">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%;" v-loading="loading" 
        @selection-change="handleSelectionChange">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column prop="product_name" label="产品" width="200px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image?scope.row.image:''" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
 
          <el-table-column prop="spec_value" label="规格" width="60"></el-table-column>
          <el-table-column prop="product_no" label="条形码"  width="80"></el-table-column>
 
          <el-table-column prop="product_price" label="价格" width="60"></el-table-column>
   
          <el-table-column prop="stock_num" label="库存" width="60"></el-table-column>
          <el-table-column prop="line_price" label="成本" width="60"></el-table-column>

          <el-table-column prop="price_type" label="价格类型" >
            <template slot-scope="scope">
                
            <el-radio-group v-model="scope.row.sku_prices.price_type">
                <el-radio  :label="1" >固定</el-radio>
                <el-radio  :label="2">比例</el-radio>
            </el-radio-group>
          
            </template>
          </el-table-column>

        <el-table-column prop="price" label="价格" width="120">
            <template slot-scope="scope">
                <el-input v-model="scope.row.sku_prices.price" placeholder="请输入价格" class="max-w460"></el-input>
            </template>
        
          </el-table-column>

          <el-table-column  label="进货价格" width="60">
            <template slot-scope="scope">
                <span v-if="scope.row.sku_prices.price_type == 1">   {{  scope.row.sku_prices.price}}</span>
             
                <span v-if="scope.row.sku_prices.price_type == 2">   {{ getPrice( ( (scope.row.sku_prices.price/100 ) *  scope.row.product_price)  )}}</span>
           </template> 
        
          </el-table-column>

          <el-table-column prop="price" label="说明" width="80">
            <template slot-scope="scope">
               <span>单独定价优先级最高</span>
            </template>
        
          </el-table-column>

          <el-table-column prop="price_type" label="是否开启" >
            <template slot-scope="scope">
                
            <el-radio-group v-model="scope.row.sku_prices.status">
                <el-radio  :label="1" >不开启</el-radio>
                <el-radio  :label="2">开启</el-radio>
            </el-radio-group>
          
            </template>
          </el-table-column>

          
          <el-table-column prop="price_type" label="是否开启折扣差" >
            <template slot-scope="scope">
                
            <el-radio-group v-model="scope.row.sku_prices.is_discount">
                <el-radio  :label="1" >不开启</el-radio>
                <el-radio  :label="2">开启</el-radio>
            </el-radio-group>
          
            </template>
          </el-table-column>


          <el-table-column prop="min_shipment" label="最低发货量" width="90">
            <template slot-scope="scope">
                 <el-input v-model="scope.row.sku_prices.min_shipment" placeholder="最低发货量" class="max-w460"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="max_shipment" label="最高发货量" width="90">
            <template slot-scope="scope">
                 <el-input v-model="scope.row.sku_prices.max_shipment" placeholder="最高发货量" class="max-w460"></el-input>
            </template>
          </el-table-column> -->
        
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button  type="primary" @click="maKeSkuPrice(scope.row)"  size="small" >定价</el-button>
              
            </template>
          </el-table-column> 
            
    
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <div style="height: 30px;"></div>


    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="maKeSkuPriceS" :disabled="loading">批量定价</el-button>
    </div>

    <GetInsUser :is_open="open_cm" :code="ucode" :multi="multi"   @close="closeCm"></GetInsUser>

    </div>
  </template>
  
  <script>
  import ProductApi from '@/api/product.js';
  import qs from 'qs';
  import GetInsUser from '@/components/user/getInsUser.vue';
  export default {
    components: {
      GetInsUser
    },
    data() {
      return {
        isupload:false,
        /*切换菜单*/
        activeName: 'all',
        /*切换选中值*/
        activeIndex: '0',
        /*是否正在加载*/
        loading: true,
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          user_search:"",
        },
        /*列表数据*/
        tableData: [],
        //用户数据
        userTableData:[],
        /*全部分类*/
        categoryList: [],
        /*选中的*/
        multipleSelection: [],
        /*选择的商品列表*/
        select_list:[],
        /*是否显示*/
        dialogVisible: false,
        // 是否加载操作页面
        more_actions:false,
        product_no_search:'',
        is_open_wholesale:false,
        curModel:{},
        is_open_scp:false,
        product_sku:{},
        showCheckStock:false,
        multipleSelection:[],
        form:{
            min_shipment:0,
            max_shipment:0,
            price:0,
            price_type:1,
        },
        open_cm:false,
        multi:false,
        ucode:""
      };
    },
    created() {
      /*获取列表*/
      this.getData();
  
    },
    methods: {
      closeCm(e){
      var self = this;
      self.open_cm=false;
      self.searchForm.user_search = e.params.user_id
      self.getData();


    },
      /*打开获取用户*/
      openGetuser(code) {
      this.open_cm = true;
      this.ucode = code;
    },
        roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        return this.roundToDecimalPlace(price,2)
      },
            /*选择sku*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },
    maKeSkuPriceS(){//批量设置价格
        var self = this;
        self.loading = true;
        var Params = {};
        if(this.multipleSelection.length <= 0){
            self.loading = false;
            self.$message({
                    message: '请选择要定价的sku',
                    type: 'error'
                    });
           return; 
        }
        Params.parmas = JSON.stringify(self.multipleSelection);
        Params.user_id = self.userTableData[0].user_id

        ProductApi.maKeSkuPrice(Params, true)
          .then(data => {
            self.loading = false;
            if(data.code == 1){

                self.$message({
                    message: '恭喜你，设置成功',
                    type: 'success'
                    });
            }
          })
          .catch(error => {
            self.loading = false;
          });  
    },
    maKeSkuPrice(row){
        var self = this;
        self.loading = true;
        var Params = {};
        Params.parmas = JSON.stringify([row]);
        Params.user_id = self.userTableData[0].user_id

        ProductApi.maKeSkuPrice(Params, true)
          .then(data => {
            self.loading = false;
            if(data.code == 1){

                self.$message({
                    message: '恭喜你，设置成功',
                    type: 'success'
                    });
            }
          })
          .catch(error => {
            self.loading = false;
          });   
    },
   
      uploadPNI(row){
          this.curModel = row
          this.isupload = true;
      },
      checkStock(row){//盘点库存
        this.showCheckStock = true
        this.curModel = row;
      },
      editAdd(e){
        console.log(e)
        this.is_open_scp = true;
        this.product_sku = e
  
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
  
      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
  
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;
        ProductApi.getUserAndSku(Params, true)
          .then(data => {
            self.loading = false;
            self.categoryList = data.data.category;
            self.tableData = data.data.sku.data;
            self.totalDataNumber = data.data.sku.total;

            self.userTableData =  data.data.user;
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
      /*打开编辑*/
      setWholesale(row){
          this.is_open_wholesale =true;
          this.curModel = row;
      },
      onSubmit(){
        this.curPage = 1;
        this.getData();
      },
      closeDialogFunc(e) {
       
  
          this.is_open_wholesale = e.openDialog;
          this.is_open_scp = e.openDialog;
          this.showCheckStock = e.openDialog
          if (e.type == 'success') {
              this.getData();
          }
  
          
      },
      checkAdd(item){
        this.$router.push({
            path: '/plus/psin/index/skustock',
            query: {
              product_sku_id: item.product_sku_id
            }
          });
      },
  
   
      
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/product/sku/sku_prices.vue